import { InfoOutlined } from '@mui/icons-material';
import { FormControl } from '@mui/material';
import { CSSProperties } from '@mui/styles';
import { ReactNode } from 'react';

import { Label, RequiredAsterisk, Tooltip } from '@components';

type FieldsetProps = {
  /** JSX to be rendered inside the fieldset. Should consist of form components. */
  children: ReactNode;
  /** The label for the fieldset. */
  label: string;
  /** Helpful text to be rendered inside a tooltip. */
  infoTooltipText?: string;
  /** Additional styles */
  style?: CSSProperties;
  required?: boolean;
};

/**
 * An MUI FormControl component that renders as an HTML fieldset. It is useful for grouping multiple related form components as per accessibility guidelines.
 */
export const Fieldset = ({
  children,
  label,
  infoTooltipText,
  required,
}: FieldsetProps) => {
  return (
    <FormControl component="fieldset" sx={{ width: 1 }}>
      <Label component="legend">
        {label}
        {required && <RequiredAsterisk />}
        {!!infoTooltipText && (
          <Tooltip title={infoTooltipText} placement="top-end">
            <InfoOutlined
              sx={{
                color: 'brandBlue.main',
                cursor: 'pointer',
              }}
            />
          </Tooltip>
        )}
      </Label>
      {children}
    </FormControl>
  );
};
